// -------------------------------------------------------
// Expandable Cards — Accordion Mode
// - Only one card can be open at a time
// - Smooth height animation using max-height
// -------------------------------------------------------

(function () {

    function setPanelHeight(panel, open) {
        if (!panel) return;

        if (open) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
            panel.style.maxHeight = '0px';
        }
    }

    function closeCard(card) {
        if (!card) return;

        var panel = card.querySelector('.expandable-card__panel');
        var button = card.querySelector('.expandable-card__toggle');

        card.classList.remove('is-open');

        if (panel) {
            setPanelHeight(panel, false);
        }

        if (button) {
            button.setAttribute('aria-expanded', 'false');

            var wrapper = card.closest('.js-expandable-cards');
            var openLabel = wrapper && wrapper.dataset.openLabel
                ? wrapper.dataset.openLabel
                : 'Read more';

            var textEl = button.querySelector('.expandable-card__toggle-text');
            if (textEl) textEl.textContent = openLabel;
        }
    }

    function openCard(card) {
        if (!card) return;

        var panel = card.querySelector('.expandable-card__panel');
        var button = card.querySelector('.expandable-card__toggle');

        card.classList.add('is-open');

        if (panel) {
            setPanelHeight(panel, true);
        }

        if (button) {
            button.setAttribute('aria-expanded', 'true');

            var wrapper = card.closest('.js-expandable-cards');
            var closeLabel = wrapper && wrapper.dataset.closeLabel
                ? wrapper.dataset.closeLabel
                : 'Show less';

            var textEl = button.querySelector('.expandable-card__toggle-text');
            if (textEl) textEl.textContent = closeLabel;
        }
    }

    function initExpandableCards() {
        var wrappers = document.querySelectorAll('.js-expandable-cards');
        if (!wrappers.length) return;

        // Ensure default-open cards have correct height on load
        wrappers.forEach(function (wrapper) {
            var openCardEl = wrapper.querySelector('.expandable-card.is-open');
            if (openCardEl) {
                var panel = openCardEl.querySelector('.expandable-card__panel');
                setPanelHeight(panel, true);
            }
        });

        document.addEventListener('click', function (e) {
            var btn = e.target.closest('.expandable-card__toggle');
            if (!btn) return;

            e.preventDefault();

            var card = btn.closest('.expandable-card');
            var wrapper = btn.closest('.js-expandable-cards');
            if (!card || !wrapper) return;

            var isOpen = card.classList.contains('is-open');

            // Close all cards in this section first
            var cards = wrapper.querySelectorAll('.expandable-card');
            cards.forEach(function (c) {
                closeCard(c);
            });

            // If it wasn't already open, open it
            if (!isOpen) {
                openCard(card);
            }
        });

        // Recalculate heights on resize (fonts / orientation changes)
        window.addEventListener('resize', function () {
            document
                .querySelectorAll('.expandable-card.is-open .expandable-card__panel')
                .forEach(function (panel) {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initExpandableCards);
    } else {
        initExpandableCards();
    }

})();